import { Input } from "antd";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { Ref } from "react";
import { getLeadingSpaces, getTrailingSpaces } from "utils/utils";

export type TextareaProps = {
    name: string;
    placeholder?: string;
    attributes?: any; // TODO optimize
    inputProps: InputComponentProps<string>;
    inputRef?: Ref<any>;
    className?: string;
};

export const Textarea = ({
    name,
    placeholder,
    inputProps,
    attributes,
    inputRef,
    className,
}: TextareaProps) => {
    const { TextArea } = Input;
    const leadingSpaces = getLeadingSpaces(inputProps.value);
    const trailingSpaces = getTrailingSpaces(inputProps.value);
    return (
        <>
            <TextArea
                autoSize={{ minRows: 1, maxRows: 6 }}
                onChange={inputProps.onChange}
                onBlur={inputProps.onBlur}
                onFocus={inputProps.onFocus}
                name={name}
                value={inputProps.value}
                placeholder={placeholder}
                className={`input input__field input__field--textarea ${className ?? ""}`}
                readOnly={inputProps.isReadOnly}
                ref={inputRef}
                autoFocus={attributes?.autoFocus}
                onKeyDown={(event) => {
                    if (attributes?.onKeyDown) {
                        attributes.onKeyDown(event);
                    }

                    if (event.key === "Enter" && !event.shiftKey && attributes?.onEnterKey) {
                        event.preventDefault();
                        attributes.onEnterKey((event.target as any).value);
                    }
                }}
            />
            {(leadingSpaces || trailingSpaces) && name === "name" && (
                <div
                    id="inputName"
                    className="input input__field input__field--textarea background-overlay"
                >
                    <div className="span-wrapper">
                        <span className="space-background">{leadingSpaces}</span>
                        <span>{inputProps.value.trim()}</span>
                        <span className="space-background">{trailingSpaces}</span>
                    </div>
                </div>
            )}
        </>
    );
};
